import React, { useState } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';

import * as actions from 'src/actions/customerGroupsActions';
import { FormView } from './FormView';
import { CustomerGroupBodyType, CustomerGroupApiType } from '../types';

type EditGroupProps = {
  editCustomerGroup: (
    id: string,
    body: CustomerGroupBodyType,
    successCallback: () => void,
    failureCallback: () => void
  ) => void;
  closeModal: () => void;
  group: CustomerGroupApiType;
  customerDetail: any;
};

const EditGroup: React.FC<EditGroupProps> = ({
  editCustomerGroup,
  closeModal,
  group,
  customerDetail,
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = (body: CustomerGroupBodyType) => {
    setLoading(true);

    if (
      body.places &&
      group.places[0]?.address?.formatted_address === body.places[0]
    ) {
      delete body.places;
    }

    editCustomerGroup(
      group.id,
      body,
      () => {
        setLoading(false);
        message.success('La communauté a bien été modifiée');
        closeModal();
      },
      () => {
        setLoading(false);
        message.error(
          'Une erreur est survenue lors de la modification de la communauté'
        );
      }
    );
  };

  return (
    <FormView
      customer={customerDetail}
      group={group}
      onSubmit={onSubmit}
      loading={loading}
    ></FormView>
  );
};

export default connect(null, actions)(EditGroup);
